import { Component, OnInit } from '@angular/core';
import { Platform } from '@ionic/angular';
import { Capacitor } from '@capacitor/core';
import { SplashScreen } from '@capacitor/splash-screen';
import { StatusBar, StatusBarStyle } from '@capacitor/status-bar';
import { TranslateService } from '@ngx-translate/core';
import { InternationalizationService } from '@services/i18n.service';
import { Router } from '@angular/router';
import { SessionService } from '@services/session.service';
import { StorageService } from '@services/storage.service';

@Component({
  standalone: false,
  selector: 'app-root',
  templateUrl: 'app.component.html',
  styleUrls: ['app.component.scss']
})
export class AppComponent implements OnInit {

  constructor(
    private platform: Platform,
    private internationalizationService: InternationalizationService,
    private translate: TranslateService,
    private router: Router,
    private sessionService: SessionService,
    private storageService: StorageService
  ) {
    this.initializeApp();
    this.initializeTranslation();
  }

  ngOnInit() {
    // this.isUserLogedIn(); //Se quita porque cuando accedo a link de recuperar contraseña me redirige a login.
  }

  // Inicializa Capacitor y gestiona plugins
  initializeApp() {
    this.platform.ready().then(() => {
      if (Capacitor.getPlatform() !== 'web') {
        // Configuración del StatusBar en móviles
        StatusBar.setStyle({ style: StatusBarStyle.Default }).catch(err => {
          console.warn('Error configurando StatusBar:', err);
        });
      } else {
        console.info('La plataforma es web, no se configura el StatusBar.');
      }

      // Ocultar SplashScreen de forma segura
      SplashScreen.hide().catch(err => {
        console.warn('Error ocultando SplashScreen:', err);
      });
    });
  }

  // Inicializa el servicio de traducción
  initializeTranslation() {
    const language = this.internationalizationService.getLanguage();
    this.translate.setDefaultLang(language);
    this.translate.use(language);
  }

  // Comprueba si el usuario está autenticado
  // isUserLogedIn() {
  //   if (!this.sessionService.isLoggedIn()) {
  //     this.storageService.clear();
  //     this.router.navigate(['/auth/login']);
  //   }
  // }
}
